import _ from 'lodash'

import {
  LIST_OAUTH_FACTORS_STARTED,
  LIST_OAUTH_FACTORS_COMPLETED,
  LIST_OAUTH_FACTORS_FAILED,

  DELETE_OAUTH_FACTOR_STARTED,
  DELETE_OAUTH_FACTOR_COMPLETED,
  DELETE_OAUTH_FACTOR_FAILED,

  CLEAR_ACTION_STATES
} from '@/store/types'
import { marshalOAuthFactor } from '@/utils/marshal'

function getDefaultState () {
  return {
    loading: false,
    done: false,
    error: undefined,

    actionLoading: false,
    actionDone: false,
    actionError: undefined,

    oAuthFactors: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    [LIST_OAUTH_FACTORS_STARTED] (state) {
      state.loading = true
    },
    [LIST_OAUTH_FACTORS_COMPLETED] (state, oAuthFactors = []) {
      state.oAuthFactors = _.cloneDeep(oAuthFactors.map(marshalOAuthFactor))

      state.loading = false
      state.error = undefined
      state.done = true
    },
    [LIST_OAUTH_FACTORS_FAILED] (state, err) {
      console.error(err)
      state.loading = false
      state.error = err
    },

    [DELETE_OAUTH_FACTOR_STARTED] (state) {
      state.actionLoading = true
    },
    [DELETE_OAUTH_FACTOR_COMPLETED] (state) {
      state.actionDone = true
      state.actionLoading = false
      state.actionError = undefined
    },
    [DELETE_OAUTH_FACTOR_FAILED] (state, err) {
      console.error(err)
      state.actionLoading = false
      state.actionError = err
    },
    [CLEAR_ACTION_STATES] (state) {
      state.actionLoading = false
      state.actionError = undefined
    }
  },
  actions: {
    async list ({ commit, rootState: { client = undefined } }, id) {
      try {
        commit(LIST_OAUTH_FACTORS_STARTED)
        const oAuthFactors = await client.managementClient.listOAuthFactors(id)
        commit(LIST_OAUTH_FACTORS_COMPLETED, oAuthFactors)
      } catch (err) {
        commit(LIST_OAUTH_FACTORS_FAILED, err)
      }
    },
    async delete ({ commit, rootState: { client = undefined } }, id) {
      try {
        commit(DELETE_OAUTH_FACTOR_STARTED)
        await client.managementClient.deleteOAuthFactor(id)
        commit(DELETE_OAUTH_FACTOR_COMPLETED)
      } catch (err) {
        commit(DELETE_OAUTH_FACTOR_FAILED, err)
      }
    }
  }
}
